module.exports = __webpack_public_path__ + "img/spirit_Image_three.8fc33020.png";